export const all = state => state.all;
export const one = state => state.one;
export const progressPercent = (state) => {
  if (state.progress) {
    return (state.progress.loaded / state.progress.total) * 100;
  }
  return null;
};
